import React from "react";
import type { FocusEvent } from "react";
import U2000InputTagBase from "./U2000InputTagBase";
import type { U2000FormStateHandlers } from "../../../reducer/formReducer/U2000FormStateHandlers";

type U2000InputTagNumericProps = {
  formStateHandlers: U2000FormStateHandlers<any>;
  fieldName: string;
  label: string;
  readonly?: boolean;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  formatter?: (val: string) => string;
  placeholder?: string;
};

/**
 * Filtre la saisie pour ne garder que les chiffres.
 * @param {string} val - Valeur saisie
 * @returns {string} Chaine filtrée
 */
function filterByType(val: string): string {
  return val.replace(/[^0-9]/g, "");
}

const U2000InputTagNumeric: React.FC<U2000InputTagNumericProps> = (props) => {
  return <U2000InputTagBase {...props} filterFunction={filterByType} />;
};

export default U2000InputTagNumeric;
